import { render, staticRenderFns } from "./SbpMedia.vue?vue&type=template&id=65976738&scoped=true&"
import script from "./SbpMedia.vue?vue&type=script&lang=js&"
export * from "./SbpMedia.vue?vue&type=script&lang=js&"
import style0 from "./SbpMedia.vue?vue&type=style&index=0&id=65976738&prod&lang=scss&"
import style1 from "./SbpMedia.vue?vue&type=style&index=1&id=65976738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65976738",
  null
  
)

export default component.exports